import React from 'react';
import { PartnerService } from 'services';
import { useQuery } from '@tanstack/react-query';
import { AccountInformationForm } from 'components';
export const AccountInformationPage = () => {
	const query = useQuery({
		queryKey: ['accountInformation'],
		queryFn: PartnerService.getCurrentPartner,
	});

	return <AccountInformationForm query={query} />;
};
